import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6873111e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8 px-5 mt-5 mx-auto" }
const _hoisted_4 = { class: "card card-primary" }
const _hoisted_5 = {
  key: 0,
  class: "overlay"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Cambiar contraseña")
], -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userOldPassword" }, "Contraseña anterior", -1))
const _hoisted_12 = { class: "input-group mb-3" }
const _hoisted_13 = ["type"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userPassword" }, "Contraseña", -1))
const _hoisted_16 = { class: "input-group mb-3" }
const _hoisted_17 = ["type"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userPasswordConfirm" }, "Confirmación de Contraseña", -1))
const _hoisted_20 = { class: "input-group mb-3" }
const _hoisted_21 = ["type"]
const _hoisted_22 = { class: "card-footer text-center" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          _hoisted_8,
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showUserOldPassword ? 'text':'password',
                    class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.userOldPassword.$error,  'is-valid': !_ctx.v$.userPassword.$error }),
                    id: "userOldPassword",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.v$.userOldPassword.$model) = $event)),
                    placeholder: "Contraseña",
                    autocomplete: "off"
                  }, null, 10, _hoisted_13), [
                    [_vModelDynamic, _ctx.v$.userOldPassword.$model]
                  ]),
                  _createElementVNode("span", {
                    class: "input-group-text rounded-left-0 rounded-right",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.showUserOldPassword = !_ctx.showUserOldPassword))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showUserOldPassword ? 'fas fa-eye-slash' : 'fas fa-eye'])
                    }, null, 2)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userOldPassword.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "error invalid-feedback",
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showUserPassword ? 'text':'password',
                    class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.userPassword.$error,  'is-valid': !_ctx.v$.userPassword.$error }),
                    id: "userPassword",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.v$.userPassword.$model) = $event)),
                    placeholder: "Contraseña",
                    autocomplete: "off"
                  }, null, 10, _hoisted_17), [
                    [_vModelDynamic, _ctx.v$.userPassword.$model]
                  ]),
                  _createElementVNode("span", {
                    class: "input-group-text rounded-left-0 rounded-right",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.showUserPassword = !_ctx.showUserPassword))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showUserPassword ? 'fas fa-eye-slash' : 'fas fa-eye'])
                    }, null, 2)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userPassword.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "error invalid-feedback",
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showUserPasswordConfirm ? 'text':'password',
                    class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.userPasswordConfirm.$error,  'is-valid': !_ctx.v$.userPasswordConfirm.$error }),
                    id: "userPasswordConfirm",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.v$.userPasswordConfirm.$model) = $event)),
                    placeholder: "Confirmación de Contraseña",
                    autocomplete: "off"
                  }, null, 10, _hoisted_21), [
                    [_vModelDynamic, _ctx.v$.userPasswordConfirm.$model]
                  ]),
                  _createElementVNode("span", {
                    class: "input-group-text rounded-left-0 rounded-right",
                    onClick: _cache[5] || (_cache[5] = $event => (_ctx.showUserPasswordConfirm = !_ctx.showUserPasswordConfirm))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([_ctx.showUserPasswordConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'])
                    }, null, 2)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userPasswordConfirm.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "error invalid-feedback",
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-block btn-success",
                onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
              }, " Guardar ")
            ])
          ])
        ])
      ])
    ])
  ]))
}